// TROIS FRAPPES DE MAILLET (05/08, retour Claude-Alain : « je veux 3 animations différentes
// pour la frappe avec le maillet »). Même recette que les 4 sauts de trampoline
// (bounce-variant.ts) : un tirage PAR COUP, déterministe depuis l'état partagé —
// `mailletReadyAt` est posé par la sim à chaque frappe (tick + CD), donc unique par coup et
// identique sur tous les clients et en rejeu. JAMAIS de Math.random côté rendu.
// La mécanique ne varie pas d'un poil (zone, vol, stun) : seul l'HABILLAGE du swing change.
export type MailletVariant = 0 | 1 | 2 // 0 bûcheron (par-dessus) · 1 toupie (tour complet) · 2 golf (remontée)

export function mailletVariant(readyAt: number, idx: number): MailletVariant {
  let h = (Math.imul(readyAt, 2246822519) + idx * 68219 + 5) >>> 0
  h = (h ^ (h >>> 13)) >>> 0
  h = Math.imul(h, 1274126177) >>> 0
  return ((h >>> 8) % 3) as MailletVariant
}

// La géométrie de chaque swing : angle du maillet (0 = dressé, positif = vers l'AVANT en
// horaire) en fonction de la progression 0..1 du coup, et teinte de la traînée.
// PURE -> testable, le bloc de rendu reste mince.
export interface SwingPose {
  ang: number         // angle courant du maillet (pivot à la poigne)
  depuis: number      // angle de DÉPART du balayage (pour peindre le secteur déjà parcouru)
  antihoraire: boolean // sens du balayage (le golf remonte : arc peint à l'envers)
  teinte: string      // "r,g,b" de la traînée : chaque frappe a sa couleur
}

export function swingPose(v: MailletVariant, t: number): SwingPose {
  if (v === 1) {
    // LA TOUPIE : un tour COMPLET autour du porteur — le maillet fauche tout le cadran.
    return { ang: -1.4 + t * (Math.PI * 2), depuis: -1.4, antihoraire: false, teinte: '190,225,255' }
  }
  if (v === 2) {
    // LE GOLF : parti d'en bas derrière, il fauche SOUS lui et remonte devant — l'uppercut.
    return { ang: -2.6 - t * 3.0, depuis: -2.6, antihoraire: true, teinte: '255,214,120' }
  }
  // LE BÛCHERON : armé derrière l'épaule, abattu par-dessus jusqu'au sol devant.
  return { ang: -1.4 + t * 2.7, depuis: -1.4, antihoraire: false, teinte: '255,240,200' }
}
